/**
 * PeaceMobiles Product Catalog
 * Curated specifications and photos for the latest lineup:
 * - Forme N17 Pro
 * - i Ultra
 * - Nova 17 Pro
 * - SC26
 * - Nova 17 Max
 * - i 17 Air
 * - Nova 17 Pro Max
 * - i 18 Air
 * - i 17 Pro
 */

export const productsData = [
  {
    id: 1,
    slug: 'forme-n17-pro',
    name: 'Forme N17 Pro',
    tagline: 'Dynamic speed. Crisp clarity. Everyday mastery.',
    series: 'Forme Series',
    category: 'forme',
    price: '$499',
    rawPrice: 499,
    badge: 'Popular Choice',
    isNew: true,
    description: 'Dynamic performance and sleek aesthetics. Engineered with high-efficiency octa-core processing, a crisp 90Hz display, and advanced 50MP AI dual-lens photography for sharp, vivid memories.',
    keyFeatures: [
      '6.56″ HD+ 90Hz Smooth Display',
      '50MP AI Dual Camera System',
      '5000 mAh All-Day Power with Fast Charging',
      '4G Dual SIM VoLTE Connectivity'
    ],
    specs: {
      display: '6.56″ HD+ (90Hz Refresh Rate, 500 nits)',
      processor: 'Octa-Core High Efficiency Performance Processor',
      camera: 'Dual: 50MP AI Main + 2MP Depth Sensor',
      battery: '5000 mAh with 18W Fast Charging',
      storage: '128GB / 256GB Expandable up to 512GB',
      material: 'Sleek Polycarbonate Glass Finish',
      connectivity: '4G LTE Dual SIM, Wi-Fi, Bluetooth 5.0'
    },
    images: [
      { id: 101, image_path: '/Photo/nova 17 pro 1.jpg', label: 'Front Showcase' },
      { id: 102, image_path: '/Photo/nova 17pro 2.jpg', label: 'Rear Perspective' }
    ]
  },
  {
    id: 2,
    slug: 'i-ultra',
    name: 'i Ultra',
    tagline: 'The pinnacle of mobile engineering and power.',
    series: 'Flagship i Series',
    category: 'flagship',
    price: '$1,199',
    rawPrice: 1199,
    badge: 'Ultimate Flagship',
    isNew: true,
    description: 'The ultimate power flagship. Uncompromising speed, aerospace titanium architecture, ultra-telephoto periscope zoom, and studio-grade cinematic video capture with next-gen Neural Engine intelligence.',
    keyFeatures: [
      'Expansive 6.8″ Quad HD+ 120Hz LTPO OLED',
      '108MP Quad Camera Matrix with 10x Optical Zoom',
      'Aerospace Titanium Unibody Design',
      '5200 mAh Battery with 65W HyperCharge'
    ],
    specs: {
      display: '6.8″ Quad HD+ LTPO OLED (1-120Hz, 2400 nits Peak)',
      processor: 'Next-Gen Ultra Bionic 3nm Chipset',
      camera: 'Quad: 108MP OIS Main + 48MP Ultra-Wide + 12MP 10x Periscope + 3D ToF',
      battery: '5200 mAh with 65W Wired & 30W Wireless Charging',
      storage: '256GB / 512GB / 1TB NVMe',
      material: 'Aerospace Grade 5 Titanium Frame with Ceramic Shield',
      connectivity: '5G Dual SIM, Wi-Fi 7, Thunderbolt USB-C'
    },
    images: [
      { id: 201, image_path: '/Photo/17pro max .jpg', label: 'Studio Showcase' },
      { id: 202, image_path: '/Photo/peace-i17-pro-poster.jpg', label: 'Poster View' },
      { id: 203, image_path: '/Photo/i7 air 2.jpg', label: 'Profile' }
    ]
  },
  {
    id: 3,
    slug: 'nova-17-pro',
    name: 'Nova 17 Pro',
    tagline: 'Pro performance crafted for dynamic creators.',
    series: 'Nova Series',
    category: 'nova',
    price: '$899',
    rawPrice: 899,
    badge: 'Creator Choice',
    isNew: true,
    description: 'Engineered for high-intensity mobile photography and seamless multitasking. Features a 144Hz HDR AMOLED display, 50MP Sony IMX CineWide optical sensor with AI night portraits, and 100W HyperCharge endurance that reaches 100% in 22 minutes.',
    keyFeatures: [
      '144Hz Smooth AMOLED Cinematic Display',
      '50MP IMX Master Sensor with 8K Video',
      '100W HyperCharge (0 to 100% in 22 mins)',
      'Vapor Chamber Liquid Cooling Architecture'
    ],
    specs: {
      display: '6.7″ 1.5K AMOLED (144Hz, 10-bit Color, 1800 nits)',
      processor: 'Snapdragon 8 Gen 3 Flagship Octa-Core',
      camera: 'Triple: 50MP Main (f/1.6 OIS) + 50MP CineWide + 12MP Portrait',
      battery: '5000 mAh with 100W HyperCharge & 50W Wireless',
      storage: '256GB / 512GB UFS 4.0',
      material: 'Aircraft Aluminum Frame with AG Frosted Glass',
      connectivity: 'Dual 5G SIM, Wi-Fi 6E, Bluetooth 5.4'
    },
    images: [
      { id: 301, image_path: '/Photo/nova 17 pro 1.jpg', label: 'Front Showcase' },
      { id: 302, image_path: '/Photo/nova 17pro 2.jpg', label: 'Back Design' },
      { id: 303, image_path: '/Photo/nova 17 pro.jpg', label: 'Profile Angle' },
      { id: 304, image_path: '/Photo/peace-nova-17-pro-poster.jpg', label: 'Poster View' }
    ]
  },
  {
    id: 4,
    slug: 'sc26',
    name: 'SC26',
    tagline: 'Performance meets Peace. Integrated precision stylus.',
    series: 'SC Series',
    category: 'sc',
    price: '$699',
    rawPrice: 699,
    badge: 'Built-in Stylus Pen',
    isNew: true,
    description: 'Engineered for creators and productivity professionals. Boasts an integrated precision stylus pen, a massive 6000mAh multi-day battery, IP68 water resistance, a high-lumen 2000 nits outdoor display, and 50MP optical stabilization.',
    keyFeatures: [
      'Integrated Precision Stylus Pen (Zero-Latency)',
      'Massive 6000mAh Battery (Up to 3 Days Usage)',
      'IP68 Military Drop & Shock Resistance',
      '2000 Nits Sunlight-Readable 6.7″ Super AMOLED'
    ],
    specs: {
      display: '6.7″ FHD+ Super AMOLED (120Hz, 2000 nits Sunlight Mode)',
      stylus: 'Built-in Precision Stylus Pen for Notes & Drawing',
      camera: 'Dual: 50MP Main (f/1.7 OIS) + 12MP Ultra-Wide',
      battery: '6000 mAh with 65W Fast Charge & Reverse Charging',
      storage: '256GB / 512GB (Expandable up to 1TB)',
      material: 'Reinforced Poly-Carbonate & Titanium-Infused Frame',
      connectivity: 'Dual SIM 5G, Wi-Fi 6, IP68 Water Resistance'
    },
    images: [
      { id: 401, image_path: '/Photo/SC26 front.jpg', label: 'Front Display' },
      { id: 402, image_path: '/Photo/SC26 back .jpg', label: 'Rugged Rear' },
      { id: 403, image_path: '/Photo/peace-sc26-poster.jpg', label: 'Poster View' }
    ]
  },
  {
    id: 5,
    slug: 'nova-17-max',
    name: 'Nova 17 Max',
    tagline: 'Maximum screen immersion. Maximum entertainment power.',
    series: 'Nova Series',
    category: 'nova',
    price: '$799',
    rawPrice: 799,
    badge: 'Max Screen',
    isNew: true,
    description: 'Maximum screen real-estate with cinematic entertainment power. Features an expansive 6.9″ edge-to-edge OLED canvas, Dolby Atmos quad-speakers, and a large-capacity 5500mAh battery for endless streaming and gaming.',
    keyFeatures: [
      'Expansive 6.9″ MaxView 120Hz OLED Display',
      '64MP AI Quad Camera System with 4K Video',
      '5500 mAh Large Capacity Battery with 45W Quick Charge',
      'Dual Stereo Speakers with Dolby Atmos'
    ],
    specs: {
      display: '6.9″ MaxView OLED (120Hz, HDR10+, 1500 nits)',
      processor: 'Octa-Core 6nm High-Speed Gaming Processor',
      camera: 'Quad: 64MP Main + 8MP Ultra-Wide + 2MP Macro + 2MP Depth',
      battery: '5500 mAh with 45W Quick Charge',
      storage: '128GB / 256GB High-Speed Storage',
      material: 'Slim Curved Aluminum & AG Glass Frame',
      connectivity: '5G Dual VoLTE, Wi-Fi 6, Bluetooth 5.2'
    },
    images: [
      { id: 501, image_path: '/Photo/17pro max .jpg', label: 'Front View' },
      { id: 502, image_path: '/Photo/nova 17 pro.jpg', label: 'Rear Perspective' },
      { id: 503, image_path: '/Photo/nova 13 front.jpg', label: 'Angle View' }
    ]
  },
  {
    id: 6,
    slug: 'i-17-air',
    name: 'i 17 Air',
    tagline: 'Ultrathin elegance. Uncompromising speed.',
    series: 'Flagship i Series',
    category: 'flagship',
    price: '$749',
    rawPrice: 749,
    badge: 'Featherlight',
    isNew: true,
    description: 'Measuring just 6.8mm thin with an ultra-lightweight body. Incorporates a vibrant 120Hz curved OLED canvas, front 32MP 4K vlog camera with autofocus, and 50MP RYYB ultra-sensing optics for crisp night captures.',
    keyFeatures: [
      'Ultra-Slim 6.8mm Architectural Profile',
      '120Hz Hyper-Curved FHD+ OLED Display',
      '50MP RYYB Ultra-Sensing Camera',
      '66W SuperCharge Rapid Top-Up'
    ],
    specs: {
      display: '6.67″ FHD+ Curved OLED (120Hz, 1200 nits)',
      processor: 'A17 Air Bionic 4nm Energy-Efficient Processor',
      camera: 'Dual: 50MP RYYB Ultra-Sensing + 8MP Ultra-Wide/Macro',
      battery: '4600 mAh with 66W SuperCharge',
      storage: '128GB / 256GB / 512GB',
      material: 'Reinforced Composite Edge with Matte Glass Finish',
      connectivity: '5G, Wi-Fi 6E, Bluetooth 5.3, NFC'
    },
    images: [
      { id: 601, image_path: '/Photo/i17air-1.jpg', label: 'Front & Profile' },
      { id: 602, image_path: '/Photo/i7 air 2.jpg', label: 'Angled Studio View' },
      { id: 603, image_path: '/Photo/nova 17 air.jpg', label: 'Back Housing' }
    ]
  },
  {
    id: 7,
    slug: 'nova-17-pro-max',
    name: 'Nova 17 Pro Max',
    tagline: 'The supreme summit of speed and camera capability.',
    series: 'Nova Series',
    category: 'nova',
    price: '$1,049',
    rawPrice: 1049,
    badge: 'Pro Summit',
    isNew: true,
    description: 'Flagship summit with ultimate camera and battery architecture. Built for demanding creators and power users who need top-tier processing, 108MP Quad OIS camera array, and 100W HyperCharge endurance.',
    keyFeatures: [
      '6.9″ 2K 144Hz LTPO AMOLED Panel',
      '108MP Quad OIS Camera System with 5x Optical Zoom',
      '100W HyperCharge (Full Charge in under 25 mins)',
      'Dual 5G Ultra-Fast Connectivity'
    ],
    specs: {
      display: '6.9″ 2K LTPO AMOLED (1-144Hz, 2200 nits)',
      processor: 'Flagship Octa-Core Performance Engine',
      camera: 'Quad: 108MP Main OIS + 48MP CineWide + 12MP 5x Telephoto + 2MP Macro',
      battery: '5400 mAh with 100W Wired & 50W Wireless',
      storage: '256GB / 512GB / 1TB',
      material: 'Titanium-Infused Frame with Nanotech Ceramic Back',
      connectivity: 'Dual 5G SIM, Wi-Fi 7, Bluetooth 5.4'
    },
    images: [
      { id: 701, image_path: '/Photo/17pro max .jpg', label: 'Front Perspective' },
      { id: 702, image_path: '/Photo/nova 17 pro 1.jpg', label: 'Camera Array' },
      { id: 703, image_path: '/Photo/nova 17pro 2.jpg', label: 'Rear Housing' }
    ]
  },
  {
    id: 8,
    slug: 'i-18-air',
    name: 'i 18 Air',
    tagline: 'Next-generation lightness. Limitless intelligence.',
    series: 'Flagship i Series',
    category: 'flagship',
    price: '$849',
    rawPrice: 849,
    badge: 'Next Gen',
    isNew: true,
    description: 'Next-generation ultra-slender profile with cutting-edge AI features, vibrant 120Hz ProMotion Super Retina display, 50MP Photonic imaging, and featherweight aeronautical composite body.',
    keyFeatures: [
      'Aeronautical Featherweight Chassis',
      '6.7″ 120Hz ProMotion Super Retina OLED',
      '50MP Main OIS Photonic Camera',
      'All-Day Battery with 45W Fast Charging'
    ],
    specs: {
      display: '6.7″ Super Retina OLED (120Hz, 1500 nits)',
      processor: 'Next-Gen i18 Neural Chipset',
      camera: 'Dual: 50MP Main (f/1.6 OIS) + 12MP Ultra-Wide',
      battery: '4800 mAh with 45W Fast Charge',
      storage: '128GB / 256GB / 512GB',
      material: 'Aeronautical Lightweight Alloy Frame',
      connectivity: '5G VoLTE, Wi-Fi 6E, Bluetooth 5.3'
    },
    images: [
      { id: 801, image_path: '/Photo/i18air-1.jpg', label: 'Front Display' },
      { id: 802, image_path: '/Photo/i18air-2.jpg', label: 'Back Cover' },
      { id: 803, image_path: '/Photo/i17air-1.jpg', label: 'Profile' }
    ]
  },
  {
    id: 9,
    slug: 'i-17-pro',
    name: 'i 17 Pro',
    tagline: 'Beyond Power. Beyond Limits.',
    series: 'Flagship i Series',
    category: 'flagship',
    price: '$999',
    rawPrice: 999,
    badge: '5G Flagship',
    isNew: true,
    description: 'Beyond Power. Beyond Limits. 5G Flagship engineered with a 6.61″ 120Hz FHD+ immersive vision display, 20MP ultra clarity AI camera, 5000 mAh all-day battery with fast charging, and dual SIM 5G connectivity.',
    keyFeatures: [
      '6.61″ FHD+ 120Hz Immersive Vision Display',
      '20MP AI Powered Ultra Clarity Rear Camera',
      '5000 mAh All-Day Power with Fast Charging',
      '5G Ultra-Fast Connectivity with Dual SIM'
    ],
    specs: {
      display: '6.61″ FHD+ (120Hz Immersive Vision, 1200 nits)',
      processor: 'Flagship Octa-Core 5G Processor',
      camera: '20MP AI Ultra Clarity Rear Camera + 8MP Front Camera',
      battery: '5000 mAh All-Day Power with Fast Charging',
      storage: '128GB / 256GB',
      material: 'Glass Front & Back with Metal Alloy Frame',
      connectivity: '5G Ultra-Fast Connectivity, DUAL SIM'
    },
    images: [
      { id: 901, image_path: '/Photo/peace-i17-pro-poster.jpg', label: 'Poster Showcase' },
      { id: 902, image_path: '/Photo/i7 air 2.jpg', label: 'Front Angle' },
      { id: 903, image_path: '/Photo/17pro max .jpg', label: 'Rear Perspective' }
    ]
  }
];

export const productCategories = [
  { id: 'all', name: 'All Phones', count: 9 },
  { id: 'flagship', name: 'Flagship i Series', count: 4 },
  { id: 'nova', name: 'Nova Series', count: 3 },
  { id: 'sc', name: 'SC Series', count: 1 },
  { id: 'forme', name: 'Forme Series', count: 1 }
];
